import { createFileRoute, redirect } from '@tanstack/react-router'

import { ForgotPasswordPage } from '@/shared/auth/components/ForgotPasswordPage'
import { postLoginRedirect } from '@/shared/auth/post-login-redirect'
import { useAuthStore } from '@/shared/auth/stores/authStore'

// Public 2-step OTP password reset flow per BE-21. Available to anyone
// who isn't currently signed in — already-authenticated users bounce
// back to their role's home so they don't accidentally reset their own
// password from a stale tab.
export const Route = createFileRoute('/auth/forgot-password')({
  beforeLoad: () => {
    const state = useAuthStore.getState()
    if (state.isAuthenticated) {
      throw redirect({ to: postLoginRedirect(state.user?.role_name) })
    }
  },
  component: ForgotPasswordPage,
})
